import { useContext, useEffect, useState } from "react";
import { TenantContext } from "../../context/tenant/TenantContext";

import "./banner.css";
import { LanguageContext } from "../../context/language/LanguageContext";

export default function Banner() {
  const { tenant } = useContext(TenantContext);
  const { language } = useContext(LanguageContext);
  const [bannerImages, setBannerImages] = useState([]);

  useEffect(() => {
    if (tenant) {
      const images = tenant.tenantbannerimage.includes(",")
        ? tenant.tenantbannerimage.split(",")
        : [tenant.tenantbannerimage];

      setBannerImages(images);

      setTimeout(() => {
        if (images.length > 1) {
          document.getElementById("btnNextWebBanner")?.click();
          document.getElementById("btnNextMobBanner")?.click();
        }
      }, 3000);
    }
  }, [tenant]);

  return (
    <div id="home" className="header_slider">
      {/* Web View */}
      <div
        id="carouselExampleAutoplaying"
        className="carousel slide d-none d-md-block"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner d-none d-md-block">
          {bannerImages?.map((image, index) => (
            <div
              className="carousel-item main-carousel-item active position-relative"
              key={index}
            >
              <img
                src={`${process.env.REACT_APP_CLOUDFRONT}tenantbannerimages/${tenant?.tenanturlname}/web_${image}`}
                className="d-block w-100"
                alt="..."
              />
              <div className="container">
                <div className="h-100 position-absolute top-0 banner-text-container-main">
                  <div className="col-10 col-md-6 h-100 banner-text-container ">
                    <h1
                      className="banner-header-text text-white fadeInUpBig"
                      style={{
                        animationDuration: "1s",
                        animationDelay: "1s",
                        animationName: "fadeInUpBig",
                      }}
                    >
                      {language?.static_labels.header_banner_heading}
                    </h1>
                    <p
                      className="banner-content-text text-white fadeInUpBig"
                      style={{
                        animationDuration: "1s",
                        animationDelay: "1s",
                        animationName: "fadeInUpBig",
                      }}
                    >
                      {language?.static_labels.header_banner_content}
                    </p>
                    {/* <button className="btn btn-primary pt-2 pb-2 p-3 pt-md-3 pb-md-3 p-md-4 mt-3 fadeInUpBig main-btn"
                                style={{
                                    animationDuration: "1s",
                                    animationDelay: "1s",
                                    animationName: "fadeInUpBig"
                                }}>{language?.static_labels.header_banner_button}</button> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {bannerImages.length > 1 && (
          <>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="next"
              id="btnNextWebBanner"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </>
        )}
      </div>

      {/* Mobile View */}
      <div
        id="carouselExampleMobAutoplaying"
        className="carousel slide d-block d-md-none"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner d-block d-md-none">
          {/* style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}${tenant?.tenantbannerimage})` }} */}
          {bannerImages?.map((image, index) => (
            <div
              className="carousel-item main-carousel-item active position-relative"
              key={index}
            >
              <img
                src={`${process.env.REACT_APP_CLOUDFRONT}tenantbannerimages/${tenant?.tenanturlname}/mob_${image}`}
                className="d-block w-100"
                alt="..."
              />
              <div className="container">
                <div className="h-100 position-absolute top-0 banner-text-container-main">
                  <div className="col-10 col-md-6 h-100 banner-text-container ">
                    <h1
                      className="banner-header-text text-white fadeInUpBig"
                      style={{
                        animationDuration: "1s",
                        animationDelay: "1s",
                        animationName: "fadeInUpBig",
                      }}
                    >
                      {language?.static_labels.header_banner_heading}
                    </h1>
                    <p
                      className="banner-content-text text-white fadeInUpBig"
                      style={{
                        animationDuration: "1s",
                        animationDelay: "1s",
                        animationName: "fadeInUpBig",
                      }}
                    >
                      {language?.static_labels.header_banner_content}
                    </p>
                    {/* <button className="btn btn-primary pt-2 pb-2 p-3 pt-md-3 pb-md-3 p-md-4 mt-3 fadeInUpBig main-btn"
                                style={{
                                    animationDuration: "1s",
                                    animationDelay: "1s",
                                    animationName: "fadeInUpBig"
                                }}>{language?.static_labels.header_banner_button}</button> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {bannerImages.length > 1 && (
          <>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleMobAutoplaying"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleMobAutoplaying"
              data-bs-slide="next"
              id="btnNextMobBanner"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
}